import { scope } from '#components/generics/js/selectors/scope.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import href from '#utilities/js/ea/href.js'
import globals from '#utilities/js/ea/globals.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    label
  ) => {
    const checkbox = one(`[type='checkbox']`, label)
    const { value } = checkbox
    const { day, view } = scope(checkbox)

    globals.ea_link_direct(href('calendar/view', {
      cal: value,
      day,
      view
    }), '', null)
  }
})

export default (label) => {
  onInput.listen(label)
}
